<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="grey darken-3"
          icon="mdi-account"
          :title="
            $route.params.id
              ? $t('Edit Peoplecourseweekregistration')
              : $t('New Peoplecourseweekregistration')
          "
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-card>
              <v-card-text>
                <h3 class="mb-5 red--text" v-if="formValues.is_waiting">
                  <strong>!! {{ $t("Warteliste") }} !!</strong>
                </h3>
                <p>
                  <strong>{{ $t("Course") }}:</strong>
                  {{ formValues.courseWeek.course.name }} -
                  {{ formValues.courseWeek.name }} [{{ formValues.courseWeek.from | formatDate }} - {{ formValues.courseWeek.to | formatDate }} ]
                </p>
                <p>
                  <strong>{{ $t("Child") }}:</strong>
                  {{ formValues.people.first_name }}
                  {{ formValues.people.last_name }}
                </p>
                <p>
                  <strong>{{ $t("day_type") }}:</strong>
                  {{ $t(formValues.day_type) }}
                </p>
                <p>
                  <strong>{{ $t("price") }}: </strong>
                  <span v-if="formValues.day_type == 'full_day'">{{
                    formValues.courseWeek.price | currency
                  }}</span>
                  <span v-else>{{
                    formValues.courseWeek.price_half_day | currency
                  }}</span>
                </p>
                <p v-if="formValues.courseWeek.course.custom_field">
                  <strong>{{ $t("custom_field") }}: </strong>
                  <span>{{ formValues.custom_field }}</span>
                </p>
                <p v-if="formValues.courseWeek.course.custom_field_2">
                  <strong>{{ $t("custom_field_2") }}: </strong>
                  <span>{{ formValues.custom_field_2 }}</span>
                </p>
                <p v-if="formValues.courseWeek.course.custom_field_3">
                  <strong>{{ $t("custom_field_3") }}: </strong>
                  <span>{{ formValues.custom_field_3 }}</span>
                </p>
                

              </v-card-text>
            </v-card>
            <v-card>
              <v-card-text>
                <template v-if="this.$auth.user().roles.includes('Superadmin')">
                  

                  <v-select
                  v-model="formValues.day_type"
                  :items="[
                    { key: 'full_day', label: $i18n.locale == 'de' ? formValues.courseWeek.course.label_full_day_de : formValues.courseWeek.course.label_full_day_it },
                    { key: 'half_day', label: $i18n.locale == 'de' ? formValues.courseWeek.course.label_half_day_de : formValues.courseWeek.course.label_half_day_it },
                  ]"
                  :label="$t('day_type')"
                  name="day_type"
                  item-text="label"
                  item-value="key"
                  data-vv-name="day_type"
                  :error-messages="errors.collect('day_type')"
                ></v-select
              >
                </template>
                <v-switch
                v-show="!formValues.courseWeek.course.disable_leave_alone"
                v-model="formValues.leave_alone"
                :label="$t('leave_alone')"
              ></v-switch>
      
              <v-switch
                v-show="!formValues.courseWeek.course.disable_swimming_help"
                v-model="formValues.swimming_help"
                :label="$t('swimming_help')"
              ></v-switch>
              <v-textarea
              rows="2"
              outlined
              v-model="formValues.medicaments"
              :label="$t('medicaments')"
              autocomplete="new-password"
              v-validate=""
              data-vv-name="medicaments"
              :error-messages="errors.collect('medicaments')"
            ></v-textarea>
              <v-textarea
              rows="2"
              outlined
              v-model="formValues.incompatibilities"
              :label="$t('incompatibilities')"
              autocomplete="new-password"
              v-validate=""
              data-vv-name="incompatibilities"
              :error-messages="errors.collect('incompatibilities')"
            ></v-textarea>
              <v-textarea
              rows="2"
              outlined
              v-model="formValues.allergies"
              :label="$t('allergies')"
              autocomplete="new-password"
              v-validate=""
              data-vv-name="allergies"
              :error-messages="errors.collect('allergies')"
            ></v-textarea>
      
              </v-card-text>
            </v-card>
            <v-card v-if="formValues.is_waiting == false">
              <v-card-text>
                <v-row >
                  <v-col>
                    <v-text-field
                      v-model="formValues.payed_amount"
                      :label="$t('payed_amount')"
                      autocomplete="new-password"
                      v-validate="'required'"
                      required
                      data-vv-name="payed_amount"
                      :error-messages="errors.collect('payed_amount')"
                    ></v-text-field>
                    <v-btn class="mr-2" small @click="setPayedComplete()">{{
                      $t("set_payed_complete")
                    }}</v-btn>
                  </v-col>
                  <v-col>
                    <base-date-picker
                      v-model="formValues.payed_at"
                      :label="$t('date')"
                      v-validate="'required'"
                      data-vv-name="payed_at"
                      :error-messages="errors.collect('payed_at')"
                    ></base-date-picker>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn
                                    small
                                    rounded
                                    target="_blank"
                                    :href="
                                      '/confirmation/' +
                                        formValues.courseWeek.course_id +
                                        '/' +
                                        formValues.people_id +
                                        '/?token=' +
                                        token
                                    "
                                    ><v-icon>mdi-download</v-icon>{{ $t("payment_confirmation") }} DE</v-btn
                                  >&nbsp;
                                  <v-btn
                                    small
                                    rounded
                                    target="_blank"
                                    :href="
                                      '/confirmation/' +
                                        formValues.courseWeek.course_id +
                                        '/' +
                                        formValues.people_id +
                                        '/it/?token=' +
                                        token
                                    "
                                    ><v-icon>mdi-download</v-icon>{{ $t("payment_confirmation") }} IT</v-btn
                                  >
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-row>
              <v-col>
                <v-textarea
                  v-model="formValues.comment_internal"
                  :label="$t('comment_internal')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="comment_internal"
                  :error-messages="errors.collect('comment_internal')"
                ></v-textarea>
              </v-col>
              <v-col>
                <v-textarea
                  v-model="formValues.comment"
                  :label="$t('comment_user')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="comment"
                  readonly
                  :error-messages="errors.collect('comment')"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="
                  $router.push({ name: 'peopleCourseWeekRegistration.index' })
                "
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem } from "../shared/services";
import moment from "moment";
export default {
  name: "app-peopleCourseWeekRegistration-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        name: ""
      },
      token:"",
      permissions: [],
      loading: true,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ]
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
    this.token = localStorage.getItem("laravel-vue-spa");
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "peopleCourseWeekRegistration.index" });
      }
    },
    setPayedComplete() {
      if (this.formValues.day_type == "full_day") {
        this.formValues.payed_amount = this.formValues.courseWeek.price;
        this.formValues.payed_at = moment().format("YYYY-MM-DD");
      } else {
        this.formValues.payed_amount = this.formValues.courseWeek.price_half_day;
        this.formValues.payed_at = moment().format("YYYY-MM-DD");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
